module.exports = __webpack_public_path__ + "static/media/TuIt.4cd38984.svg";